<template>
	<div>
		<article
			class="iv2-article"
			v-if="pageActive"
		>
			<div v-if="news.open_type === 1 && indexOpenType === 1">
				<BaseTitle
					:items="items"
					:public-lang="publicLang"
				/>
				<LayoutDetail
					:news="news"
					:public-lang="publicLang"
				/>
			</div>

			<Error404
				v-else-if="news.open_type === 0 || indexOpenType === 0"
				:public-lang="publicLang"
			/>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import BaseTitle from '@/components/items/BaseTitle.vue';
import LayoutDetail from './components/LayoutDetail.vue';
import BaseLoading from '@/components/items/BaseLoading.vue';
import Error404 from '@/components/systems/Page404.vue';
import Meta from '@/mixins/MetaSettable';
import Preview from '@/mixins/Preview';

export default {
	components: {
		BaseTitle,
		LayoutDetail,
		BaseLoading,
		Error404
	},

	mixins: [Meta, Preview],

	props: {
		language: String,
		publicLang: Object
	},

	data() {
		return {
			news: [],
			items: {
				title: '',
				subtitle: '',
				header_type: 'text_only'
			},
			indexOpenType: '',
			pageActive: false,
			loading: true
		}
	},

	mounted() {
		this.axios.get('/news', {
			params: {
				hl: this.language,
			}
		}).then(({data}) => {
			this.items.title = data.response.title;
			this.items.subtitle = data.response.subtitle;
			if (this.$route.query.mode == 'preview') {
				this.indexOpenType = 1;
			} else {
				this.indexOpenType = data.response.open_type;
			}
		}).catch(() => {
			this.indexOpenType = 0;
		});
		

		const id = this.$route.params.id;
		if (this.$route.query.mode == 'preview' && this.$route.query.api_token) {
			this.axios.get('/preview/news/' + id + '/show', {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				},
				params: {
					hl: this.language,
				}
			}).then((response) => {
				this.news = response.data.response;
			}).catch(() => {
				this.indexOpenType = 0;
			}).finally(() => {
				this.loading = false;
				this.pageActive = true;
			});
		} else {
			this.axios.get('/news/' + id + '/show', {
				params: {
					hl: this.language,
				}
			}).then((response) => {
				this.news = response.data.response;
				if (this.$route.query.mode == 'preview') {
					this.news.open_type = 1;
				}
			}).catch(() => {
				this.indexOpenType = 0;
			}).finally(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}
	}
}
</script>

<style lang="scss"></style>